import * as React from "react";
import {CSSProperties} from "react";

export class Content extends React.Component<ContentProps, ContentState> {
    static defaultProps: Partial<ContentProps> = {};

    constructor(props: ContentProps) {
        super(props);
        this.state = {
            MaxHeight:this.GetMaxHeight()
        };
        this.UpdateDimension=this.UpdateDimension.bind(this);
    }

    componentDidMount(){
        window.addEventListener("resize", this.UpdateDimension);
    }

    componentWillUnmount(){
        window.removeEventListener('resize',this.UpdateDimension);
    }

    public UpdateDimension(){
        this.setState({MaxHeight:this.GetMaxHeight()});
    }

    public render() {
        return (
            <div className={'rnContent'} style={{maxHeight:this.state.MaxHeight,overflowY:'auto',...this.props.style}}>
                {this.props.children}
            </div>
        )
    }

    private GetMaxHeight() {
        var elem = (document.compatMode === "CSS1Compat") ?
            document.documentElement :
            document.body;
        return elem.clientHeight*.7;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ContentProps {
    style:CSSProperties;
}

interface ContentState {
    MaxHeight:number;
}

//#endregion "My Region"